// extracted by mini-css-extract-plugin
export default {"root":"mo6XIt","label":"y1p_48","link":"pAUH_5","container":"tXbs2f","icon":"WQHAHr"};